import React from 'react';
import { css } from 'aphrodite';
import styles from './re-authenticate-styles';
import { FilledGreenButton } from '../common';

import { FaEnvelope, FaLock } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const ReAuthenticateView = (props) => (
  <div className={css(styles.root)}>

    <h1 className={css(styles.title)}>
      Login
    </h1>
    <div className={css(styles.description)}>
      It looks like your session expired. For security reasons, please login again
    </div>

    <div className={css(styles.content)}>
      <div style={{ position: 'relative' }}>
        <div className={css(styles.inputIconContainer)}><FaEnvelope className={css(styles.inputIcon)} /></div>
        <input placeholder={'email'} type={'email'} className={css(styles.input)} value={props.email} onChange={props.onChangeEmail} />
      </div>
      <div style={{ position: 'relative' }}>
        <div className={css(styles.inputIconContainer)}><FaLock className={css(styles.inputIcon)} /></div>
        <input onKeyDown={props.handleKeyDown} placeholder={'password'} type={'password'} className={css(styles.input)} value={props.password}
          onChange={props.onChangePassword} />
      </div>
      <FilledGreenButton disabled={props.disabled} title={'Login'} onClick={props.login} loading={props.loading} />
    </div>




    <NavLink to={'/reset-password'} className={css(styles.forgottenPasswordLink)}>
      Forgot password?
    </NavLink>

  </div>
);

export default ReAuthenticateView;



// WEBPACK FOOTER //
// ./src/components/login/re-authenticate-view.js